export default __webpack_public_path__ + "static/media/chevron_right.eb539a4d.svg";